module.exports = __webpack_public_path__ + "2fa165084e0e6b37c3088481512560de.svg";